import { lazy } from '@/service/lazy'

export default [{
  name: 'Limite Cadastros Diário',
  path: 'limite-cadastros-diarios',
  id: 'limite_cadastros_diarios',
  icon: 'fa fa-user-plus',
  component: lazy('app/default/gerenciador/limitecadastrosdiarios/index'),
  meta: { requireAuth: true, rules: ['gerenciar_limite_cadastros_landingpage'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/limitecadastrosdiarios.js